// extracted by mini-css-extract-plugin
module.exports = {"main":"Table2_main__c4aKP","list":"Table2_list__2pjUb","firstItemBold":"Table2_firstItemBold__33x1H","link":"Table2_link__er87X"};